import ReactDOM from 'react-dom';
import { Global } from '@emotion/react';
import { useEffect } from 'react';
import { getBackdropGlobalStyles, getBackdropStyles } from './BackdropStyles.js';
import { useKeyPress } from '../../utils/hooks/useKeyPress.js';
import { useGigerConfig } from '../../providers/useGigerConfig.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { CLASS_DIALOG_BODY_OPEN } from '../Dialog/constants/className.js';

const BACKDROP_DEFAULT_DATA_ID = 'backdrop-area';
const Backdrop = _ref => {
  let {
    'data-id': dataId = BACKDROP_DEFAULT_DATA_ID,
    isOpen,
    applyToBody,
    onClick,
    onEnter,
    ...rest
  } = _ref;
  useEffect(() => {
    if (!applyToBody) {
      return;
    }
    const bodyClassList = document.body.classList;
    const classListModified = bodyClassList.contains(CLASS_DIALOG_BODY_OPEN);
    if (isOpen && !classListModified) {
      bodyClassList.add(CLASS_DIALOG_BODY_OPEN);
    } else if (!isOpen && classListModified) {
      bodyClassList.remove(CLASS_DIALOG_BODY_OPEN);
    }
    return () => {
      bodyClassList.remove(CLASS_DIALOG_BODY_OPEN);
    };
  }, [applyToBody, isOpen]);
  const handleOnEnter = event => {
    event.preventDefault();
    onEnter === null || onEnter === void 0 ? void 0 : onEnter(event);
  };
  const {
    handleKeyPress
  } = useKeyPress({
    onEnter: handleOnEnter
  });
  const gigerConfig = useGigerConfig();
  if (!isOpen) {
    return null;
  }
  const backdrop = jsxs(Fragment, {
    children: [jsx(Global, {
      styles: getBackdropGlobalStyles
    }), jsx("div", {
      "aria-roledescription": "backdrop area",
      css: getBackdropStyles,
      tabIndex: 0,
      "data-id": dataId,
      role: "button",
      onClick: onClick,
      onKeyUp: handleKeyPress,
      ...rest
    })]
  });
  return applyToBody ? /*#__PURE__*/ReactDOM.createPortal(backdrop, gigerConfig.emotionCacheShadowRootContainer || document.body) : backdrop;
};

export { BACKDROP_DEFAULT_DATA_ID, Backdrop };
//# sourceMappingURL=Backdrop.js.map
